import { useEffect, useMemo, useState } from 'react';
import { Bell, ProductIcons, ProductPageSocialLinks } from '../components';
import { useKeenSlider } from 'keen-slider/react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { LazyLoadImage } from '@components/reactLazyLoadImageComponent';
import UIicons from '@ui-kit';
import { createImageErrorHandler } from '@utils/onImageError';
import Arrow from '@components/Carousel/components/Arrow';
import './index.scss';
import Badges from '@root/src/ui/components/ProductCard/componentsNew/Badges';
import Favorite from '../FavoriteBtn';
import Lightbox from '@components/Lightbox';
import clsx from 'clsx';
import ProductTask from '../ProductTask';
import VideoPlayer from '@components/VideoPlayer';
import ProductImage18Plus from '@components/ProductImage18Plus';
import { observer } from 'mobx-react';

const { productCardErrorImg } = UIicons;
const onImageSrcErrorHandler = createImageErrorHandler(productCardErrorImg.x3);

const THUMBS_LENGTH = 4;
const PPMobileImage = observer(
  ({
    is_18plus,
    isConsentModalAgreed,
    isBarMenu = false,
    id,
    isFavorite,
    badges,
    isFreeze,
    isExpressPickupAval,
    isExpressDeliveryAval,
    title,
    images,
    videos,
    // isDisabledPopup,
    isShowBell,
    isProductNotForSale,
    isProductArchieved,
    isMobile,
    isTablet,
    task
  }) => {
    const mediaArr = useMemo(
      () =>
        [...(images || []), ...(videos || [])].length
          ? [...(images || []), ...(videos || [])]
          : [
              {
                type: 'img',
                src: productCardErrorImg.x3
              }
            ],
      [images, videos]
    );
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [sliderRef, instanceRef] = useKeenSlider({
      rubberband: false,
      drag: !isVideoPlaying,
      mode: 'snap',
      loop: true,
      slides: {
        spacing: 0,
        origin: 'center',
        perView: 1
      },
      slideChanged(slider) {
        const current = slider.track.details.rel;
        setCurrentSlide(current);
      },
      created() {
        setLoaded(true);
      }
    });
    useEffect(() => {
      instanceRef?.current?.update();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mediaArr]);
    const [isImageOpened, setIsImageOpened] = useState(false);
    const sources = useMemo(
      () =>
        mediaArr
          .map(item => {
            if (item.type === 'img') {
              return item.original || item.src;
            }
            return null;
          })
          .filter(Boolean),
      [mediaArr]
    );

    const isVideo = mediaArr[currentSlide]?.type === 'video';
    return (
      <>
        <Lightbox
          type='image'
          toggler={isImageOpened}
          sourceIndex={currentSlide}
          sources={sources}
        />
        <div className='pp-mobile-image'>
          <div className='pp-mobile-image__wrapper'>
            {!isBarMenu && !isProductNotForSale && !isProductArchieved && (
              <div
                className={clsx(
                  'pp-mobile-image__actions pp-mobile-block-to-hide',
                  isVideoPlaying && ' pp-mobile-block-to-hide--hidden'
                )}
              >
                <Favorite
                  id={id}
                  isMobile={isMobile || isTablet}
                  isFavorite={isFavorite}
                />
                <ProductPageSocialLinks />
                {isShowBell && (
                  <Bell
                    id={id}
                    // isDisabledPopup={isDisabledPopup}
                    isMobile={isMobile || isTablet}
                  />
                )}
              </div>
            )}
            {badges?.length > 0 && (
              <div
                className={clsx(
                  'pp-mobile-block-to-hide',
                  isVideoPlaying && ' pp-mobile-block-to-hide--hidden'
                )}
              >
                <Badges badges={badges} isBehaveAsLink={!isBarMenu} />
              </div>
            )}
            {task && (
              <div className='absolute bottom-0 left-0 z-10 '>
                <ProductTask task={task} isMobile />
              </div>
            )}
            <div
              className={clsx(
                'pp-mobile-block-to-hide',
                isVideoPlaying && ' pp-mobile-block-to-hide--hidden'
              )}
            >
              <ProductIcons
                isFreeze={isFreeze}
                isExpressPickupAval={isExpressPickupAval}
                isExpressDeliveryAval={isExpressDeliveryAval}
                height={16}
              />
            </div>

            <div className='pp-mobile-image__main-slider'>
              {is_18plus && !isConsentModalAgreed ? (
                <ProductImage18Plus image={images?.[0]?.src} />
              ) : (
                !!mediaArr?.length && (
                  <div ref={sliderRef} className='keen-slider'>
                    {mediaArr.map((item, index) => (
                      <div
                        key={`${item.src}-${index}`}
                        className={'keen-slider__slide'}
                      >
                        {item.type === 'img' ? (
                          <LazyLoadImage
                            draggable={false}
                            onClick={() => {
                              setIsImageOpened(prev => !prev);
                            }}
                            onError={onImageSrcErrorHandler}
                            className='pp-mobile-image__image'
                            src={item.src || productCardErrorImg.x3}
                            alt={`${title}-${index}}`}
                          />
                        ) : (
                          <div className='pp-player'>
                            <LazyLoadComponent
                              visibleByDefault={index === currentSlide}
                            >
                              <VideoPlayer
                                url={item.src}
                                width='100%'
                                height={isMobile ? '254' : '490'}
                                playerVars={{
                                  controls: 1,
                                  cc_load_policy: 0,
                                  fs: 1,
                                  rel: 0,
                                  showinfo: 0
                                }}
                                onPause={() => setIsVideoPlaying(false)}
                                onPlay={() => setIsVideoPlaying(true)}
                              />
                              {/* <YoutubePlayer
                      key={item.src}
                      onVideoStartFunc={() => setIsVideoPlaying(true)}
                      onPause={() => setIsVideoPlaying(false)}
                      width={370}
                      height={265}
                      videoId={item.src}
                      autoplay={0}
                      loop={1}
                      fs={1}
                      controls={0}
                    /> */}
                            </LazyLoadComponent>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )
              )}

              {mediaArr.length > 1 && loaded && instanceRef && (
                <div
                  className={clsx(
                    'pp-mobile-block-to-hide',
                    isVideoPlaying && 'pp-mobile-block-to-hide--hidden'
                  )}
                >
                  <div
                    className={`hover:animate-blink absolute z-0 left-0 top-1/2 -translate-y-1/2 w-1/4 flex items-center justify-center cursor-pointer select-none  ${
                      isVideo ? 'h-[10.5rem]' : 'h-full'
                    }`}
                    onClick={e => {
                      e.stopPropagation();
                      instanceRef.current?.prev();
                    }}
                  >
                    <Arrow
                      className='pp-mobile-image__arrow'
                      left
                      height='24'
                    />
                  </div>
                  <div
                    onClick={e => {
                      e.stopPropagation();
                      instanceRef.current?.next();
                    }}
                    className={`hover:animate-blink absolute z-0 right-0 top-1/2 -translate-y-1/2 w-1/4 flex items-center justify-center cursor-pointer select-none ${
                      isVideo ? 'h-[10.5rem]' : 'h-full'
                    }`}
                  >
                    <Arrow
                      className='pp-mobile-image__arrow pp-mobile-image__arrow--right'
                      right
                      height='24'
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='pp-mobile-image__thumbs'>
            {mediaArr.slice(0, THUMBS_LENGTH).map((item, index) => {
              const isActive =
                currentSlide > 3
                  ? index === Math.round(currentSlide % THUMBS_LENGTH)
                  : index === currentSlide;
              return (
                <div
                  key={`${item.src}-thumb-${index}`}
                  className={clsx(
                    'pp-mobile-image__thumb',
                    isActive && 'pp-mobile-image__thumb--active'
                  )}
                />
              );
            })}
          </div>
        </div>
      </>
    );
  }
);

export default PPMobileImage;
